import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { UserContext } from '@irian-ro/util-user';

type HasSignUpRightGuardType = {
  setConfig: (config: { signupRights: Array<string>; redirectUrl: string }) => CanActivateChildFn;
};

//const starting in uppercase in order to have the same API as with classes
export const HasSignUpRightGuard: HasSignUpRightGuardType = {
  setConfig: (config) => {
    return () => {
      const userContext = inject(UserContext);
      const router = inject(Router);

      if (config) {
        if (!userContext.hasExactRights(config.signupRights)) {
          return true;
        }
        // Redirect to the signup page
        return router.parseUrl(config.redirectUrl);
      } else {
        throw new Error('HasSignUpRightGuard configuration is missing.  Use "HasSignUpRightGuard.setConfig"');
      }
    };
  },
};
